<template>
	<app-content class="h-panel">
		<div class="h-panel-bar">
			<span class="h-panel-title"><template v-if="auxiliary">{{auxiliary.name}} -</template> 核算项目余额</span>
		</div>
		<Row type="flex" :space-x="10" class="margin-right-left margin-top no-print">
			<Cell>
				<account-date-choose v-model="accountDate"/>
			</Cell>
			<Cell>
				<span class="range-sep">至</span>
				<DatePicker type="month" v-model="endMonth" format="YYYY-MM" placeholder="结束月份(可选)" :clearable="true" style="width: 130px;"></DatePicker>
			</Cell>
			<Cell class="label">辅助类别：</Cell>
			<Cell>
				<Select type="object" v-model="auxiliary" :deletable="false" style="min-width: 100px" :datas="auxiliaryType" keyName="id" titleName="name"/>
			</Cell>
			<Cell>
				<Button :disabled="!auxiliary" :loading="loading" color="primary" @click="doSearch">查询</Button>
			</Cell>
			<Cell>
				<Button icon="fa fa-download" @click="doExport">导出</Button>
				<Button icon="fa fa-print" @click="doPrint">打印</Button>
			</Cell>
			<Cell :flex="1"></Cell>
		</Row>
		<div class="h-panel-body">
			<div class="print-header">
				<div class="print-title"><template v-if="auxiliary">{{auxiliary.name}} - </template>核算项目余额表</div>
				<div class="print-sub">
					<span>编制单位：{{currentAccountSets?currentAccountSets.companyName:''}}</span>
					<span>期间：{{printPeriod}}</span>
					<span>单位：元</span>
				</div>
			</div>
			<table class="balance" v-if="auxiliary">
				<thead class="header">
				<tr>
					<td rowspan="2">{{auxiliary.name}}编码</td>
					<td rowspan="2">{{auxiliary.name}}名称</td>
					<td colspan="2">期初余额</td>
					<td colspan="2">本期发生额</td>
					<td colspan="2">期末余额</td>
				</tr>
				<tr>
					<td>借方</td>
					<td>贷方</td>
					<td>借方</td>
					<td>贷方</td>
					<td>借方</td>
					<td>贷方</td>
				</tr>
				</thead>
				<tbody>
				<template v-for="(item, index) in dataList">
					<tr v-if="item.code == null" :key="index" class="total-row">
						<td colspan="2" align="center"><b>{{item.name}}</b></td>
						<td align="right"><b>{{item.beginningDebitBalance|numFormat}}</b></td>
						<td align="right"><b>{{item.beginningCreditBalance|numFormat}}</b></td>
						<td align="right"><b>{{item.currentDebitAmount|numFormat}}</b></td>
						<td align="right"><b>{{item.currentCreditAmount|numFormat}}</b></td>
						<td align="right"><b>{{item.endingDebitBalance|numFormat}}</b></td>
						<td align="right"><b>{{item.endingCreditBalance|numFormat}}</b></td>
					</tr>
					<tr v-else :key="index">
						<td>{{item.code}}</td>
						<td><span class="text-hover primary-color" @click="goDetail(item)">{{item.name}}</span></td>
						<td align="right">{{item.beginningDebitBalance|numFormat}}</td>
						<td align="right">{{item.beginningCreditBalance|numFormat}}</td>
						<td align="right">{{item.currentDebitAmount|numFormat}}</td>
						<td align="right">{{item.currentCreditAmount|numFormat}}</td>
						<td align="right" :class="{tip:item.endingDebitBalance<0}">{{item.endingDebitBalance|numFormat}}</td>
						<td align="right" :class="{tip:item.endingCreditBalance<0}">{{item.endingCreditBalance|numFormat}}</td>
					</tr>
				</template>
				<tr v-if="!dataList.length">
					<td colspan="8" class="text-center padding">暂无数据</td>
				</tr>
				</tbody>
			</table>
		</div>
	</app-content>
</template>

<script>
	import moment from 'moment';
	import {mapState} from 'vuex';
	import {exportCsv} from '../../js/common/export-file';

	export default {
		name: "AuxiliaryAccountingBalance",
		data() {
			return {
				dataList: [],
				showNumPrice: false,
				loading: false,
				accountDate: null,
				endMonth: null,
				auxiliary: null,
				auxiliaryItem: {},
				auxiliaryType: [],
				auxiliaryList: []
				}
			},
			computed: {
				...mapState(['currentAccountSets']),
				printPeriod() {
					if (!this.accountDate) {
						return '';
					}
					let s = moment(this.accountDate).format('YYYY年MM月');
					if (this.endMonth && moment(this.endMonth, 'YYYY-MM').isAfter(moment(this.accountDate), 'month')) {
						s += ' 至 ' + moment(this.endMonth, 'YYYY-MM').format('YYYY年MM月');
					}
					return s;
				}
			},
		methods: {
			loadAuxiliaryType() {
				this.$api.setting.accountingCategory.list().then(({data}) => {
					this.auxiliaryType = data;
					if (data.length) {
						this.auxiliary = data[0];
					}
				});
			},
			loadList() {
				if (this.auxiliary) {
					this.loading = true;
					let params = {
						accountDate: this.accountDate,
						auxiliaryId: this.auxiliary.id
					};
					if (this.endMonth && moment(this.endMonth, 'YYYY-MM').isAfter(moment(this.accountDate), 'month')) {
						params.endAccountDate = moment(this.endMonth, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
					}
					this.$api.accountbook.loadAuxiliaryBalance(params).then(({data}) => {
						this.dataList = data;
					}).finally(() => {
						this.loading = false;
					});
				}

			},
			doSearch() {
				this.loadList();
			},
			doExport() {
				if (!this.dataList.length) {
					this.$Message.error('暂无数据可导出');
					return;
				}
				let name = this.auxiliary ? this.auxiliary.name : '核算项目';
				let headers = ['编码', '名称', '期初借方', '期初贷方', '本期借方', '本期贷方', '期末借方', '期末贷方'];
				let rows = this.dataList.map(item => [
					item.code, item.name,
					item.beginningDebitBalance, item.beginningCreditBalance,
					item.currentDebitAmount, item.currentCreditAmount,
					item.endingDebitBalance, item.endingCreditBalance
				]);
				exportCsv(name + '余额表-' + (this.accountDate ? moment(this.accountDate).format('YYYYMM') : '全部') + (this.endMonth ? '-' + moment(this.endMonth, 'YYYY-MM').format('YYYYMM') : ''), headers, rows);
			},
			doPrint() {
				window.print();
			},
			//联查：跳转辅助明细账并定位到该核算项目，携带当前期间
			goDetail(item) {
				if (!item.code || !this.auxiliary) {
					return;
				}
				let query = {
					auxiliaryId: this.auxiliary.id,
					itemCode: item.code,
					accountDate: moment(this.accountDate).format('YYYY-MM-DD')
				};
				if (this.endMonth) {
					query.endMonth = this.endMonth;
				}
				this.$router.push({name: 'AuxiliaryAccountingDetail', query});
			}
		},
		mounted() {
			this.loadAuxiliaryType();
		}
	}
</script>

<style scoped lang="less">
	.range-sep {
		margin: 0 8px;
		line-height: 30px;
		vertical-align: middle;
	}
	.balance {
		width: 100%;
		border-collapse: collapse;

		td {
			padding: 0 8px;
			border: 1px solid #e2e2e2;
			font-size: 12px;
			height: 35px;

			&.tip {
				background-color: #FFEEEF;
			}
		}

		tbody tr:nth-child(even) {
			background-color: #f8fbf8;
		}

		tbody tr:hover {
			background-color: #F0F6FF;
		}

		.header {
			td {
				background-color: #F5F5F5;
				text-align: center;
				font-weight: bold;
			}
		}
	}
</style>